import React from 'react';
import clsx from 'clsx';
import { FormControlLabel, Switch, Typography, Tooltip } from "@mui/material";
import './ReactToggle.scss';

const noop = () => { };

/**
 *
 * @param {{
 *  classes: Object;
 *  hidden: boolean;
 *  labelOff: string;
 *  toggleValue: boolean;
 *  note: string;
 *  labelOn: string;
 *  labelWrapperClass: *;
 *  disabled?: boolean;
 *  labelText?: string;
 *  ToggleFct?: (checked: boolean, event: React.ChangeEvent<HTMLInputElement>) => void;
 * }} param0
 */
const ReactToggle = ({
    disabled = false,
    hidden,
    labelOff,
    labelOn,
    labelText,
    labelWrapperClass,
    note,
    ToggleFct = noop,
    toggleValue,
    tooltipOnDisabled = null,
    isDisclaimerShown = true
}) => {
    const [open, setOpen] = React.useState(false);
    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        if (disabled && !!tooltipOnDisabled) {
            setOpen(true);
        }
    };

    return (
        <React.Fragment>
            <Tooltip open={open} onClose={handleClose} onOpen={handleOpen} title={tooltipOnDisabled}>
                <span>
                    {labelText ?
                        <div className={clsx('toggle-label-wrapper', labelWrapperClass)}>
                            <Typography className="toggle-label" >{labelText}</Typography>
                        </div>
                        : ''}
                    <FormControlLabel
                        className="toggle-auto-switch"
                        control={<Switch
                            size="small"
                            onChange={(event, checked) => { ToggleFct(checked, event) }}
                            checked={toggleValue}
                            color="primary"
                            disabled={disabled} />
                        }
                        label={
                            <Typography className="toggle-form-control-label">
                                {toggleValue ? labelOn : labelOff}
                            </Typography>
                        }
                        hidden={hidden}
                     />
                </span>
            </Tooltip>
            {!hidden && isDisclaimerShown ?
                <p>
                    <small className="toggle-note">{note}</small>
                </p>
            : ''}
        </React.Fragment>
    )
};

export default ReactToggle;